/**
 * Textareaコンポーネント
 * 
 * 複数行テキスト入力用コンポーネント
 */

import React, { forwardRef } from 'react';

export interface TextareaProps 
  extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
  variant?: 'default' | 'ghost';
}

export const Textarea = forwardRef<HTMLTextAreaElement, TextareaProps>(
  ({ className = '', variant = 'default', ...props }, ref) => {
    const baseClasses = 
      'flex min-h-[80px] w-full rounded-md px-3 py-2 text-sm ' +
      'ring-offset-background placeholder:text-muted-foreground ' +
      'focus-visible:outline-none focus-visible:ring-2 ' +
      'focus-visible:ring-ring focus-visible:ring-offset-2 ' +
      'disabled:cursor-not-allowed disabled:opacity-50';

    const variantClasses = {
      default: 'border border-input bg-background',
      ghost: 'resize-none border-0 p-0 focus-visible:ring-0 focus-visible:ring-offset-0',
    };

    return (
      <textarea
        className={`${baseClasses} ${variantClasses[variant]} ${className}`}
        ref={ref}
        {...props}
      />
    );
  }
);

Textarea.displayName = 'Textarea';